import { RequestStatus } from "../../../request";
import moment from "moment";

export interface OverviewState {
  report: OverviewReport | null;

  datepickerStartDate: Date;
  datepickerEndDate: Date;

  fetchOverviewRequestState: RequestStatus;
}

export const initialState: OverviewState = {
  report: null,

  datepickerStartDate: moment().subtract(0, "d").toDate(),
  datepickerEndDate: moment().subtract(0, "d").toDate(),

  fetchOverviewRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  },
};

export function Overview(state = initialState, action: any) {
  switch (action.type) {
    case "overview-update-request-state":
      return {
        ...state,
        fetchOverviewRequestState: action.requestState,
      };
    case "overview-deactivate-campaign":
      let campaigns = [...state.report.campaigns];

      campaigns.forEach((c) => {
        if (c.id === action.id) {
          c.status = action.isActive;
        }
      });

      return {
        ...state,
        report: {
          ...state.report,
          campaigns: campaigns,
        },
      };
    case "overview-update-campaign-after-suggestion":
      if (!state.report) return state;
      
      const updatedCampaigns = state.report.campaigns.map(campaign => {
        if (campaign.id === action.campaignId) {
          const isBidUpdate = action.updatedValues.bid !== undefined;
          const isBudgetUpdate = action.updatedValues.dailyBudgetCap !== undefined;
          
          const filteredSuggestions = Array.isArray(campaign.suggestions) 
            ? campaign.suggestions.filter(suggestion => {
                if (isBidUpdate && suggestion.bidIncrease) return false;
                if (isBudgetUpdate && suggestion.budgetCapMultiplier) return false;
                return true;
              })
            : [];
          
          return {
            ...campaign,
            ...action.updatedValues,
            suggestions: filteredSuggestions
          };
        }
        return campaign;
      });
      
      return {
        ...state,
        report: {
          ...state.report,
          campaigns: updatedCampaigns
        }
      };
    case "overview-update-report":
      return {
        ...state,
        report: action.report,
      };
    case "overview-update-date-ranges":
      return {
        ...state,
        datepickerStartDate: action.startDate,
        datepickerEndDate: action.endDate,
      };
    case "reset-data":
      return initialState;
    default:
      return state;
  }
}

export enum CampaignPlatforms {
  "ios",
  "android",
}

export interface GraphRow {
  date: Date;
  installs: number;
  spend: number;
}

export interface Campaign extends CampaignDetails {
  status: boolean;
  isDirect: boolean;
  installs: number;
  appName: string;
  appId: string;
  clicks: number;
  spend: number;
  conversion_rate: number;
}

export interface RoasGoal {
  dx: string;
  url: number;
}

export interface Creative {
  type: string;
  url: string;
}

export interface Suggestion {
  id: number;
  bidIncrease?: number;
  budgetCapMultiplier?: number;
}

export interface CampaignDetails {
  id: string;
  name: string;
  iconUrl: string;
  mmp: string | null;
  playStoreUrl: string;
  countries: string[] | null;
  genders: number[] | null;
  minAge: number | null;
  maxAge: number | null;
  minApiLevel: number | null;
  maxApiLevel: number | null;
  bid: number;
  biddingType: string;
  dailyBudgetCap: number;
  clickUrl: string;
  platform?: "android" | "ios";
  appStoreUrl?: string;
  roas_goals?: RoasGoal[];
  creatives?: Creative[];
  suggestions?: Suggestion[];
  biddingEvent?: string | null;
}

export interface OverviewReport {
  from: Date;
  until: Date;
  totalInstalls: number;
  totalSpend: number;
  graphRows: GraphRow[];
  campaigns: Campaign[];
}
